import React from "react";
import { useTranslation } from "react-i18next";
import { Page, PageHeader } from "../../../components/ui";
import CommentModeration from "./CommentModeration";

/** Latest comments of the site: pin, heart, reply as Alain Foka, delete. */
const Comments = () => {
  const { t } = useTranslation();
  return (
    <Page>
      <PageHeader
        title={t("Comments")}
        subtitle={t("Latest comments of the site. Pin a comment, give Alain Foka's heart, reply on his behalf or delete.")}
      />
      <CommentModeration />
    </Page>
  );
};

export default Comments;
